import { Box } from "@material-ui/core";
import { FC } from "react";

import CancelOrder from "./CancelOrder";
import ShowOrderDetailsButton from "./ShowOrderDetailsButton";

const ListRowActions: FC<any> = (props) => {
  const order = props.record;

  return (
    <Box display="flex" alignItems="center">
      <ShowOrderDetailsButton record={order} />
      <CancelOrder record={order} />
    </Box>
  );
};

export default ListRowActions;
